module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p', [_vm._v("Client for Tab 90 Days")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8"
    }
  }, [_c('h5', [_c('small', [_vm._v("Air Exort")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Client Filter",
      "id": "clientNameFilter",
      "name": "clientNameFilter"
    },
    on: {
      "input": function($event) {
        _vm.getNinghtyDaysPendingClientJobListFunc('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientNameFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientNameFilter", $$v)
      },
      expression: "Filter.clientNameFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All Branch",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": function($event) {
        _vm.getNinghtyDaysPendingClientJobListFunc('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [(_vm.getNinghtyDaysPendingClientJobList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getNinghtyDaysPendingClientJobList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.ExcelBtnName) + "\n        "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "responsive": "",
      "items": _vm.getNinghtyDaysPendingClientJobList,
      "fields": _vm.ninghtyDayField,
      "primary-key": "clientId"
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "clientName",
      fn: function(row1) {
        return [_c('span', [_vm._v("Client Type : " + _vm._s(row1.item.clientType)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Client Name : " + _vm._s(row1.item.clientName)), _c('br')])]
      }
    }, {
      key: "clientSeries",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.clientSeries)), _c('br')])]
      }
    }, {
      key: "lastAssignmentNumber",
      fn: function(row4) {
        return [_c('span', [_vm._v("Last Job No : " + _vm._s(row4.item.lastAssignmentNumber)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Last Job Date : " + _vm._s(row4.item.lastAssignmentDate)), _c('br')])]
      }
    }, {
      key: "clientId",
      fn: function(row2) {
        return [(row2.item.clientId) ? _c('JobHistory', {
          attrs: {
            "PMC_title": 'Last 10 Job History Client - ' + row2.item.clientName,
            "PMC_ClientID": row2.item.clientId,
            "PMC_ClientName": row2.item.clientName,
            "PMC_ClientEmail": row2.item.email,
            "PMC_ClientPhone": row2.item.phoneKYC,
            "PMC_ClientSeries": row2.item.clientSeries,
            "PMC_Filter": _vm.Filter
          }
        }) : _vm._e(), _vm._v(" "), (row2.item.clientId) ? _c('AddClientMOM', {
          attrs: {
            "PMC_title": 'Add Client MOM - ' + row2.item.clientName,
            "PMC_ClientID": row2.item.clientId,
            "PMC_ClientName": row2.item.clientName,
            "PMC_ClientEmail": row2.item.email,
            "PMC_ClientPhone": row2.item.phoneKYC,
            "PMC_ClientSeries": row2.item.clientSeries,
            "PMC_Filter": _vm.Filter,
            "PMC_mom_id": 0,
            "PMC_mom_Data": {}
          }
        }) : _vm._e(), _vm._v(" "), (row2.item.clientId) ? _c('ViewClientMOM', {
          attrs: {
            "PMC_title": 'View Client MOM - ' + row2.item.clientName,
            "PMC_ClientID": row2.item.clientId,
            "PMC_ClientName": row2.item.clientName,
            "PMC_ClientEmail": row2.item.email,
            "PMC_ClientPhone": row2.item.phoneKYC,
            "PMC_ClientSeries": row2.item.clientSeries,
            "PMC_Filter": _vm.Filter
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "8",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d8ebd2c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientJob/AirExp.vue
// module id = 2668
// module chunks = 0